import React from 'react';
import { Link, useLocation, Navigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import heroBg from '../assets/auth/logistics-hero.png';
import { LEGAL_PAGES } from '../content/legalPages';
import '../styles/legal-page.css';

const SLUG_ALIASES = {
  'refund-policy': 'refund',
};

function resolveSlug(raw) {
  if (!raw) return null;
  const key = SLUG_ALIASES[raw] || raw;
  return LEGAL_PAGES[key] ? key : null;
}

const LegalPage = () => {
  const { pathname } = useLocation();
  const raw = pathname.replace(/^\//, '');
  const key = resolveSlug(raw);
  if (!key) return <Navigate to="/" replace />;

  const page = LEGAL_PAGES[key];

  return (
    <div className="legal-page">
      <section className="legal-hero" aria-labelledby="legal-title">
        <div className="legal-hero__bg" style={{ backgroundImage: `url(${heroBg})` }} />
        <div className="legal-hero__overlay" />
        <div className="legal-hero__inner">
          <motion.div initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>
            <p className="legal-hero__crumb">
              <Link to="/">Home</Link>
              <span aria-hidden> &gt; </span>
              {page.eyebrow}
            </p>
            <p className="legal-hero__eyebrow">{page.eyebrow}</p>
            <h1 id="legal-title" className="legal-hero__title">
              {page.title}
            </h1>
            {page.lastUpdated ? (
              <p className="legal-hero__meta">Last updated: {page.lastUpdated}</p>
            ) : null}
          </motion.div>
        </div>
      </section>

      <div className="legal-shell">
        <article className="legal-article">
          {(page.sections || []).map((section) => (
            <section key={section.heading} className="legal-section">
              <h2>{section.heading}</h2>
              {(section.body || []).map((para) => (
                <p key={para.slice(0, 40)}>{para}</p>
              ))}
              {section.links?.length ? (
                <ul className="legal-links">
                  {section.links.map((l) => (
                    <li key={l.to}>
                      <Link to={l.to}>
                        {l.label}
                        <ArrowRight className="w-4 h-4" aria-hidden />
                      </Link>
                    </li>
                  ))}
                </ul>
              ) : null}
            </section>
          ))}
          <p className="legal-footer-cta">
            Questions? <Link to="/contact">Contact our team</Link>
          </p>
        </article>
      </div>
    </div>
  );
};

export default LegalPage;
